import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

export type UseTablePaginationStore = {
  page: number;
  rowsPerPage: number;
  maxPage: number;
};

const defaultValue: UseTablePaginationStore = {
  page: 1,
  rowsPerPage: 5,
  maxPage: 10,
};

// const useTablesPaginationStore = create<UseTablePaginationStore>(() => ({
//   ...defaultValue,
// }));

const useTablesPaginationStore = create(
  subscribeWithSelector<UseTablePaginationStore>(() => ({
    ...defaultValue,
  }))
);

export const useTablePage = () =>
  useTablesPaginationStore((state) => state.page);

export const useTableRowsPerPage = () =>
  useTablesPaginationStore((state) => state.rowsPerPage);

export const useTableMaxPage = () =>
  useTablesPaginationStore((state) => state.maxPage);

// export const useTablePagination = () =>
//   useTablesPaginationStore((state) => state);

export const useTablePagination = useTablesPaginationStore;

export const changeTablePage = (page: number) =>
  useTablesPaginationStore.setState({ page });

export const changeTableMaxPage = (maxPage: number) =>
  useTablesPaginationStore.setState({ maxPage });

export const changeTableRowsPerPage = (rowsPerPage: number) =>
  useTablesPaginationStore.setState({ rowsPerPage, page: defaultValue.page });

export const resetTablePage = () =>
  useTablesPaginationStore.setState({ page: defaultValue.page });

export const resetTableStore = () =>
  useTablesPaginationStore.setState({ ...defaultValue });
